import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ConfirmationService, MessageService } from 'primeng/api';

import { AuthService } from '../../service/auth.service';
import { UserProfileService } from '../../service/user-profile.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  showVerficationOverlay: boolean;
  loginForm: FormGroup;


  constructor(
    public authService: AuthService,
    private userProfileService: UserProfileService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.buildLoginForm();
  }

  buildLoginForm() {
    this.loginForm = this.fb.group({
      email: '',
      password: '',
    });
  }

  // convenience getter for easy access to form fields
  get loginControls() { return this.loginForm.controls; }

  tryLogin() {
    this.email = this.loginControls.email.value;
    this.password = this.loginControls.password.value;

    this.authService.doLogin(this.email, this.password)
      .then(res => {
        this.isUserActive(res.user);
      }, err => {
        this.showLoginError(err);
      });
  }

  showLoginError(err) {
    let msg;
    switch (err.code) {
      case 'auth/wrong-password': {
        msg = 'The password supplied was not correct.';
        break;
      }
      case 'auth/invalid-email': {
        msg = 'The email address provided is not valid.';
        break;
      }
      case 'auth/user-not-found': {
        msg = 'We do not recognize your userId / email.';
        break;
      }
      case 'auth/user-disabled': {
        msg = 'Your account is disabled. Please send an email to info@phlotilla.com.';
        break;
      }
      default: {
        msg = err.message;
        break;
      }
    }
    this.messageService.add({
      key: 'modal', severity: 'warn', summary: 'Login Error', detail: msg, life: 6000, data: {
        onConfirm: this.onTryAgain.bind(this),
        onReject: this.onForgotPassword.bind(this),
        confirmBtnLabel: 'Try Again',
        rejectBtnLabel: 'Forgot my Password'
      }
    });
  }

  onTryAgain() {
    this.messageService.clear('modal');
  }

  onForgotPassword() {
    this.messageService.clear('modal');
    this.router.navigate(['/forgot-password']);
  }

  tryGoogleLogin() {
    this.authService.doGoogleLogin()
      .then(() => {
        // popup modal welcome message here, only once per new user
        const uid = this.authService.getCurrentUser() ? this.authService.getCurrentUser().uid : '';
        this.userProfileService.isUserAckWelcome(uid)
          .then(res => {
            if (res) {
              const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
              this.router.navigate([returnUrl]);
            } else {
              this.router.navigate(['userwelcome']);
            }
          });
      });
  }

  checkIsEmailVerified(user: any) {
    if (user.emailVerified) {
      // popup modal welcome message here, only once per new user
      this.userProfileService.isUserAckWelcome(user.uid)
        .then(res => {
          if (res) {
            const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
            this.router.navigate([returnUrl]);
          } else {
            this.router.navigate(['userwelcome']);
          }
        });
    } else {
      this.authService.sendEmailVerification(false);
      this.showVerficationOverlay = true;
    }
    // this.cdRef.detectChanges();
  }

  isUserActive(user: firebase.User) {
    this.userProfileService.isUserActive(user.uid)
      .then(res => {
        if (res) {
          this.checkIsEmailVerified(user);
        } else {
          this.promptToActivateProfile(user.uid);
        }
      });
  }

  resendEmail() {
    this.authService.sendEmailVerification(false);
  }

  continue() {
    this.showVerficationOverlay = false;
    this.router.navigate(['/']);
  }

  promptToActivateProfile(uId: string) {
    this.confirmationService.confirm({
      message: 'Your profile is currently disabled. Would you like to activate it now?',
      header: 'Activate Profile',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.userProfileService.updateUserProfileStatus(uId, true)
          .then(() => {
            this.messageService.add({ key: 'info', severity: 'success', summary: 'Success', detail: 'Profile activated' });
            this.router.navigate(['/']);
          })
          .catch(error => {
            this.messageService.add({ key: 'info', severity: 'error', summary: 'Error', detail: 'Can\'t activate profile' });
          });
      },
      reject: () => {
        this.messageService.add({ key: 'info', severity: 'warn', summary: 'Warn', detail: 'Profile is still disabled' });
        this.router.navigate(['/']);
      }
    });
  }
}

